// extracted by mini-css-extract-plugin
export default {"wrapper":"CircleIcon_wrapper__HEm7n"};